import React from 'react';

import './onboardingprogressbar.css';

export default function OnboardingProgressBar (props)
{
    const status = props?.status || 32;

    const isDeleted = +status === 40;

    const statusMapping = {
        32: 'Request Submitted',
        33: 'MFR Submitted Technical Details',
        34: 'SAP MDM Setups Done',
        35: 'SAP Material Configured',
        36: 'SAP Test PO Generated',
        37: 'RITM Submitted For EDI',
        38: 'EDI Testing Status',
        39: 'MFR Live In Production'
    };

    return (
        <div className="progress-container">
            {Object.keys(statusMapping).map(key => {
                return (
                    <div className={(+status === +key && !isDeleted) ? "progress-block active" : "progress-block"} key={key}>
                        <svg className="chevron-bg" viewBox="0 0 100 100" preserveAspectRatio="none">
                            <polygon points="0,0 85,0 100,50 85,100 0,100 15,50" />
                        </svg>
                        <span className="progress-text">{statusMapping[key]}</span>
                    </div>
                );
            })}
        </div>
    );
}